import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    date: String,
    locale: String,
    refreshInterval: Number
  };

  connect() {
    // Check if Intl.RelativeTimeFormat is supported
    if (typeof Intl === 'undefined' || !Intl.RelativeTimeFormat) {
      console.log('Intl.RelativeTimeFormat is not supported in this browser.');
      return;
    }

    this.locale = this.localeValue || this.getNavigatorLanguage();
    this.setTimeText();

    if (this.hasRefreshIntervalValue) {
      this.refreshTimer = setInterval(() => {
        this.setTimeText();
      }, this.refreshIntervalValue);
    }
  }

  disconnect() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  setTimeText() {
    this.timeAgoText = this.fromToday(Date.parse(this.dateValue));
    this.element.innerText = this.timeAgoText;
  }

  fromToday = (initialTime) => {
    let timeDiff;
    let isAfter = false;
    let now = new Date();

    if (now > initialTime) {
      timeDiff = now - initialTime;
    } else {
      timeDiff = initialTime - now;
      isAfter = true;
    }

    // amount of milliseconds in each time period
    const units = {
      // approximates, because different years/months have different values
      // this should not matter too much because we only display the largest unit
      // so we do not require extreme accuracy most of the time
      year: 24 * 60 * 60 * 1000 * 365,
      month: (24 * 60 * 60 * 1000 * 365) / 12,
      // exact
      day: 24 * 60 * 60 * 1000,
      hour: 60 * 60 * 1000,
      minute: 60 * 1000,
      second: 1000
    };

    // define the rtf options
    const rtf = new Intl.RelativeTimeFormat(this.locale, {
      numeric: 'auto'
    });

    for (const unit in units) {
      const numMs = units[unit];
      if (timeDiff > numMs) {
        const value = Math.round(timeDiff / numMs);
        const parsed = rtf.format(isAfter ? value : -value, unit);
        return parsed;
      }
    }

    /**
     * rtf smallest unit is second
     * so if this function has not returned, it means that timeDiff < 1 second
     */

    switch (this.locale) {
      case 'nl':
        return 'nu net';
      case 'de':
        return 'Grade eben';
      case 'fr':
        return 'juste maintenant';
    }

    return 'just now';
  };

  getNavigatorLanguage = () => {
    if (navigator.languages && navigator.languages.length) {
      return navigator.languages[0];
    } else {
      return (
        navigator.userLanguage ||
        navigator.language ||
        navigator.browserLanguage ||
        'en'
      );
    }
  };
}
